import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const actions = createActions({
  TASK: {
    GET_COUNT: undefined,
    API: {
      GET_COUNT: apiResourceActionCreator('taskCount')
    }
  }
})

export const apiAction = (authToken) => commonApiActions.authenticated.get(`${API_ENDPOINT}/count`, authToken, actions.task.api.getCount);

function* getCount(action) {
  const authToken = yield select(authTokenSelector);

  yield put(apiAction(authToken));
}

const configuration = {
  name: 'getCount',
  action: actions,
  sagas: getCount,
  reducers: {
    request: (state, action) => ({
      ...state
    }),
    success: (state, action) => ({
      ...state,
      taskCount: action.payload.taskCount
    }),
    failed: (state, action) => ({
      ...state
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/task/configurations/getCount.js